// @ts-check
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../homePageStyles';
import DropDownIcon from '../../../assets/icons/drop.png';
import { HomePageTable1 } from '../../Stock/constants';
import { ToolTipElement } from '../../Stock/ToolTipElement';
import CustomDataTable from '../../../components/CustomDataTable';
import { HOMEPAGE_SUMMARY_SECTOR_COLUMNS } from '../../../constants/homePageConstants';
import { fetchOptionSummaryAction } from '../../../actions/fetchOptionSummaryAction';

/** @type {React.FC<import('../../../typings').IOptionSummaryTableProps>} */
const OptionSummaryTable = ({
  pageState,
  setPageState,
  changeGrouponTable,
}) => {
  const dispatch = useDispatch();
  const { toggleTable3Dropdown } = pageState;
  /** @type {import('../../../typings').IStateReducerState} */
  const { isMobile, homeThirdTable, ThirdLoading, weekendErrorsBox3 } =
    useSelector((state) => state.appReducer);

  useEffect(() => {
    dispatch(fetchOptionSummaryAction(pageState));
  }, [pageState.currentDate]);

  const tooltipClickHandler = () =>
    setPageState({
      ...pageState,
      currentType: 'hometable3',
      showModal: true,
    });
  const rowClickHandler = (row, keyName) => {
    if (keyName === 'description') changeGrouponTable(row.description);
  };

  return (
    <div>
      <div
        style={
          isMobile
            ? {
                display: 'flex',
                marginTop: '7.2%',
                marginLeft: '1%',
              }
            : { display: 'flex', width: '50%', marginTop: '2%' }
        }
      >
        {isMobile && (
          <div
            style={styles.dropDown3}
            onClick={() =>
              setPageState({
                ...pageState,
                toggleTable3Dropdown: !toggleTable3Dropdown,
              })
            }
          >
            <img height="15px" width="15px" src={DropDownIcon} alt="test" />
          </div>
        )}
        <div style={isMobile ? styles.headingStyleMobile : styles.headingStyle}>
          Options Summary By Sectors
        </div>
        <div style={{ marginTop: '2.2%', marginLeft: '1%' }}>
          <ToolTipElement
            text={HomePageTable1}
            clickHandler={tooltipClickHandler}
          />
        </div>
      </div>

      {isMobile && pageState.toggleTable3Dropdown === false ? (
        ''
      ) : (
        <div
          style={
            isMobile
              ? { ...styles.boardModalTableContainerMobile }
              : { ...styles.boardModalTableContainer, width: '98%' }
          }
        >
          <CustomDataTable
            columns={HOMEPAGE_SUMMARY_SECTOR_COLUMNS}
            rows={homeThirdTable}
            loading={ThirdLoading}
            clickHanlder={rowClickHandler}
            error={weekendErrorsBox3}
          />
        </div>
      )}
    </div>
  );
};

export default OptionSummaryTable;



// WEBPACK FOOTER //
// ./src/Pages/HomePage/Tables/OptionSummaryTable.jsx